import { Stack, Typography } from "@mui/material";
import WushTextField from "./WushTextField";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import Calendar from "@demark-pro/react-booking-calendar";

export default function WushDateTimeField({ onChange, defaultValue}) {
  const [ rawDate, setRawDate ] = useState(defaultValue || new Date());
  const [ date, setDate ] = useState(defaultValue ? format(defaultValue, 'yyyy-MM-dd') : '');
  const [ time, setTime ] = useState(defaultValue ? format(defaultValue, 'HH:mm') : '');

  useEffect(() => {
    if(!date || !time) return;

    const dateTime = new Date(`${date}T${time}`);
    onChange(dateTime);
  }, [date, time]);

  console.log(date, time);

  return (
    <Stack>
      <Calendar
        onChange={(date) => {
          setRawDate(date[0]);
          setDate(format(date[0], 'yyyy-MM-dd'));
        }}
        selected={[rawDate]}
        variant="events"
      />
      <Stack>
        <Typography variant="body1">Time:</Typography>
        <WushTextField formRegistration={{ onChange: (e) => setTime(e.target.value) }} type="time" defaultValue={time}  />
      </Stack>
    </Stack>
  );
}